import React, { useEffect } from 'react';
import useCurrentUser from '../../hooks/useCurrentUser';
import DefaulIcon from '../../assets/images/profile.png';
import SlackIcon from '../../assets/images/slack.svg';
import { useLazyGetEmployeeOverviewQuery } from '../../features/apis/authApi';
import TaraLog from '../../assets/images/chatLogo.svg';
import ViewMore from './ViewMore';
import UpcomingEvents from './UpcomingEvents';
import { IoIosEye } from 'react-icons/io';
import WorkHours from './WorkHours';
import DashboardCardSkeleton from '../../components/Skeletons/DashboardCardSkeleton';
function EmployeeDashBoard() {
  const user = useCurrentUser();
  const [getOverview, { data, isLoading }] = useLazyGetEmployeeOverviewQuery();
  useEffect(() => {
    if (user?._id) {
      getOverview(user?._id);
    }
  }, [getOverview, user]);
  if (isLoading) {
    return <DashboardCardSkeleton />;
  }
  return (
    <div className="p-6 space-y-4 font-poppins">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 items-stretch">
        <div className="bg-white flex gap-3 p-2 col-span-1 md:col-span-2 rounded h-full">
          <img
            src={user?.avatar || DefaulIcon}
            className="h-16 w-16 rounded-full mt-4"
          />
          <p className="flex flex-col w-2/5 p-4">
            <span>Hi,</span>
            <span className="text-[#6E3EF5]">{user?.name?.split(' ')[0]}!</span>
            <span className="text-xs w-2/3">{user?.designation}</span>
          </p>
          <div className="w-2/5 flex flex-col justify-center gap-2">
            <p className="bg-[#CBF6D5] px-4 py-1 flex items-center justify-between rounded w-full">
              <span className="flex items-center text-xs gap-1">
                <img src={SlackIcon} className="h-4 w-4" />
                slack
              </span>
              <span className="text-xs md:text-sm text-[#326F40]">
                {data?.data?.slackStatus === true ? 'Active' : 'Inactive'}
              </span>
            </p>
            <p className="bg-[#F6DDCB] px-2 md:px-4 py-1 flex items-center rounded w-full">
              <IoIosEye color="#DCA47C" />
              <span className="text-[8px] md:text-xs ml-2 text-[#484848]">
                View your Task Reports
              </span>
            </p>
          </div>
        </div>

        {/* Card 2 */}
        <div className="bg-white flex flex-col px-4 py-4 rounded h-full gap-1">
          <p className="text-[#6E3EF5] pt-2 text-xs">{data?.data?.dateToday}</p>
          <p className="p-0 ">{data?.data?.logsToday}</p>
          <div className="flex items-center justify-between   text-white  gap-2">
            <span className="bg-[#41C55E] rounded px-2 py-1 text-xs w-2/5">
              Mark In
            </span>
            <span className="bg-[#D75151] px-2 py-1 text-xs rounded w-3/5">
              Not Yet Mark Out
            </span>
          </div>
        </div>

        {/* Card 3 */}
        <div
          className="bg-gradient-to-r from-[#6E3EF5] to-[#40248F] flex flex-col justify-between px-3 py-6 rounded h-full cursor-pointer"
          onClick={() => window.dispatchEvent(new CustomEvent('open-tara-chatbot'))}
        >
          <div className="flex items-center">
            <img src={TaraLog} className="h-14 w-14" />
            <div className="ml-2">
              <p className="text-lg text-white m-0">Ask TARA!</p>
              <p className="text-[10px] m-0 text-white/50 w-full">
                Meet our all-new AI Assistant Chatbot that gives you the freedom
                to do more.
              </p>
            </div>
          </div>
        </div>
      </div>

      <ViewMore data={data?.data} />
      <div className="flex flex-col md:flex-row justify-between w-full gap-4 h-full mb-6">
        <div className="w-full md:w-3/4 flex-grow ">
          <WorkHours />
        </div>
        <div className="w-full md:w-1/4 flex-grow">
          <UpcomingEvents />
        </div>
      </div>
    </div>
  );
}

export default EmployeeDashBoard;
